import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import api from '../../services/api';
import { getAiVisCssVars } from './aivisTheme';
import './ai-vis.css';

export default function AcceptInvitePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    async function preview() {
      if (!token) {
        setError('This invitation link is missing a token.');
        return;
      }
      try {
        const { data } = await api.get('/aivis/auth/invite/preview/', { params: { token } });
        if (!cancelled) setEmail(data.email || '');
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.detail || 'This invitation is invalid or expired.');
      }
    }
    preview();
    return () => {
      cancelled = true;
    };
  }, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Password and confirmation do not match.');
      return;
    }
    setBusy(true);
    try {
      await api.post('/aivis/auth/invite/accept/', {
        token,
        name: name.trim(),
        password,
        confirm_password: confirmPassword,
      });
      navigate('/ai-vis/login', { replace: true, state: { invited: true } });
    } catch (err) {
      setError(err.response?.data?.detail || 'Could not activate your account.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="aivis-auth-page" style={getAiVisCssVars()}>
      <div className="aivis-auth-card">
        <h1>Accept invitation</h1>
        <p>
          Create your account
          {email ? ` for ${email}` : ''}. Use your full name as it should appear in the workspace.
        </p>
        {error && <div className="aivis-auth-error">{error}</div>}
        <form onSubmit={onSubmit}>
          <div className="aivis-field">
            <label htmlFor="aivis-invite-name">Full name</label>
            <input
              id="aivis-invite-name"
              type="text"
              autoComplete="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              minLength={2}
              required
            />
          </div>
          <div className="aivis-field">
            <label htmlFor="aivis-invite-pw">Password</label>
            <input
              id="aivis-invite-pw"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>
          <div className="aivis-field">
            <label htmlFor="aivis-invite-pw2">Confirm password</label>
            <input
              id="aivis-invite-pw2"
              type="password"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              minLength={8}
              required
            />
          </div>
          <button type="submit" className="aivis-btn-primary" disabled={busy || !token}>
            {busy ? 'Saving…' : 'Activate account'}
          </button>
        </form>
        <div className="aivis-auth-link">
          <Link to="/ai-vis/login">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
